import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventsService, PaymentService, PaymentV2Service, StorageService, UtilService, VariablesService, VwoService } from '../../../../shared/services';
import { IPaymentSipConfig } from '../../../payment-sip/payment-sip.model';
import { IContribute } from '../../../payment/models/contribute.model';
import { PaymentUtilService } from '../../../payment/services';

@Component({
  selector: 'app-payment-otd',
  templateUrl: './payment-otd.component.html',
  styleUrls: ['./payment-otd.component.scss']
})
export class PaymentOtdComponent implements OnInit {

  @Input() InputConfig;
  config: IPaymentSipConfig;
  landingCurrency;
  lastPaymentMode;
  contriDetails: IContribute;
  clientData;
  oneTapOtpPopup;
  loadPayment;
  screenName;
  params;
  subs: Subscription[] = [];
  captchaForm: FormGroup;
  enableCaptha;
  max_donation = 50000000;
  @ViewChild('paymentModule', { static: true }) public paymentRef: TemplateRef<any>;
  isMobile: any;
  isIos;

  constructor(
    private util: UtilService,
    public vars: VariablesService,
    private paymentService: PaymentService,
    public paymentV2: PaymentV2Service,
    private storage: StorageService,
    public dialog: MatDialog,
    private paymentUtil: PaymentUtilService,
    public events: EventsService,
    public actRoute: ActivatedRoute,
    private vwo: VwoService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util.isMobile();
    this.isIos = this.util.isIOSDevice();
    this.setConfig(this.InputConfig);
    this.params = this.actRoute.snapshot.queryParams
    this.landingCurrency = this.config?.currency || this.storage.getFromSession('currency');
    this.getContributeDetails(this.landingCurrency);
    this.subs.push(this.vars.userData.subscribe(res => this.setConfig({ user: res })));
    this.subs.push(this.vars.clientLocationData.subscribe(res => this.clientData = res));
    this.util.addCssToGlobal('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
    this.captchaForm = new FormGroup({ captcha: new FormControl('', Validators.required) });
    if (this.params['st'] === 'f' && this.config?.optionsCheck) {
      this.openPaymentPopup('options', this.paymentRef)
    }
  }

  getContributeDetails(currency) {
    let qParam = `?currency=${currency}`;
    if (this.config.showTip) {
      qParam = qParam.concat(`&tip_only=${this.config.showTip}`);
    }
    this.paymentService.getContributeDetails(this.config.fundraiser.id, qParam).subscribe((res: any) => {
      this.contriDetails = { ...res.data.data };
      if (this.config.showTip) {
        if (this.params?.st === 'f' && this.params?.tip_amount) {
          this.contriDetails.default_amount = +this.params?.tip_amount;
        }
        if (this.config.tip_only) {
          this.setConfig({ fundraiser: this.contriDetails.campaign });
        }
      }
      this.getPaymentOptions(currency);
      if (this.params['st'] !== 'f' && !this.config.onpage && !this.config.onAmtForm) {
        this.paymentV2.eventForInitiatePayment(9, this.config.fundraiser);
      }
      this.paymentV2.isContributeInitEventHit = true;
    });
  }

  getPaymentOptions(currency) {
    let params = `&mobile_no=${this.config?.user?.phone_1}&is_mobile=${this.util.isMobile() ? 1 : 0}&amount=${this.config.amount}`;
    this.paymentService.getPaymentOptions(currency, params).subscribe((res: any) => {
      const configData = {
        amount: this.contriDetails.default_amount,
        currency: currency,
        paymentDetails: this.contriDetails,
        paymentOptions: res.data,
        donateBtnLabel: `${this.InputConfig?.donateBtnLabel || 'Donate'} <span class="amount-otd">${this.util.formatAmount(this.contriDetails.default_amount, currency)}</span>`
      }
      if (this.vwo.quickDonate_fallback_p1_AB()?.match('v2')) {
        configData.donateBtnLabel = `${this.InputConfig?.donateBtnLabel || 'Donate'}`;
      }
      if (this.vwo.quickDonate_fallback_p1_AB()?.match('v1') && this.config?.user?.lastorder) {
        configData.donateBtnLabel = `${this.InputConfig?.donateBtnLabel || 'Donate'} <span class="amount-otd">${this.util.formatAmount(this.config?.user?.lastorder?.donated_amount_local, currency)}</span>`;
      }
      if (this.vwo.quickDonate_fr_AB() && !this.config.showTipCard) {
        configData.donateBtnLabel = `${this.InputConfig?.donateBtnLabel || 'Donate'} <span class="amount-otd">${this.util.formatAmount(this.config?.user?.lastorder?.donated_amount_local, currency)}</span>`;
        configData.amount = this.config.user.lastorder.donated_amount_local;
      }
      if (this.config.showTipCard) {
        configData.donateBtnLabel = this.config?.tipAmount ? `Tip <span class="amount-otd">${this.util.formatAmount(this.config?.tipAmount, currency)}</span>` : `Tip <span class="amount-otd">${this.util.getCurrencyIcon(this.landingCurrency).symbol}0</span>`;
      }
      this.setConfig(configData);
      this.setLastPayMode(currency);
    });
  }


  setLastPayMode(currency) {
    if (this.config.recentPayMode) {
      this.lastPaymentMode = this.config.recentPayMode;
    } else if (this.config.paymentOptions.options.PREVIOUSPAYMENTGATEWAY) {
      this.lastPaymentMode = Object.values(this.config.paymentOptions.options.PREVIOUSPAYMENTGATEWAY)[0];
    } else if (currency === 'INR' && this.isMobile && !this.isIos && ((this.config?.order?.donated_amount_local <= 100000 || this.config?.user?.lastorder?.donated_amount_local <= 100000) || (!this.config?.order?.donated_amount_local || !this.config?.user?.lastorder?.donated_amount_local))) {
      this.lastPaymentMode = {
        payment_mode: 'UPI',
        payment_mode_value: 'GooglePay'
      };
    } else {
      this.lastPaymentMode = null;
    }
    if (this.lastPaymentMode?.payment_mode === 'UPI' && this.lastPaymentMode?.payment_mode_value !== 'VPA' && (this.isIos || !this.isMobile)) {
      this.lastPaymentMode = null;
    }
  }

  async createCart(type, template?) {
    this.paymentV2.selectedButtonId.next(this.config.buttonId);
    if (this.config.amount < this.config?.paymentDetails?.min_donation) {
      return false;
    }
    if (this.config.amount > this.max_donation) {
      return false;
    }
    if (this.config.onpage && !this.config.onAmtForm && !this.config.showTipCard) {
      this.paymentV2.eventForInitiatePayment(9, this.config.fundraiser);
    }
    if ((this.vwo.quickDonate_fallback_p1_AB() === 'v1' || this.vwo.quickDonate_fallback_p1_AB() === 'v2') && this.config?.user?.lastorder && !this.config?.recentPayMode) {
      this.setConfig({
        amount: this.config?.user?.lastorder?.donated_amount_local
      });
    } else if (this.vwo.quickDonate_fallback_p1_AB() === 'v2' && this.config?.user?.lastorder && this.config?.recentPayMode) {
      this.setConfig({
        amount: this.config?.order?.donated_amount_local
      });
    }
    if (this.lastPaymentMode === null) {
      this.util.router.navigate([], { queryParams: { payment: 'options' }, queryParamsHandling: 'merge' });
    }
    const cartPayload = {
      campaign_id: this.config.fundraiser.id,
      currency: this.config.currency,
      amount: this.config.amount,
      is_anonymous: this.config.paymentDetails.is_anonymous ? '1' : '0',
      tip_amount: this.config.tipAmount || null,
      skipmin: this.config.showTip || (this.vwo.quickDonate_fallback_p1_AB() === 'v1') || (this.vwo.quickDonate_fallback_p1_AB() === 'v2') || false
    };
    if (this.config.showTip && this.config.showTipCard) {
      cartPayload.amount = this.config?.user?.lastorder?.donated_amount_local + (this.config?.tipAmount || 0);
    }
    if (this.config.tip_only && this.config.showTip) {
      cartPayload.tip_amount = this.config.amount;
      cartPayload.skipmin = true;
    }
    if ((this.util.actRoute.snapshot.queryParams.or === 'up' && this.util.actRoute.snapshot.queryParams?.tip_amount) || (this.vars?.pageName === 'update' && cartPayload.tip_amount !== 0) || this.vars?.pageName === 'standalonetip') {
      this.util.router.navigate([], { queryParams: { frtip: 'true' }, queryParamsHandling: 'merge' });
    }

    this.paymentV2.captchaResponse = this.captchaForm.get('captcha').value || '';
    const cartResp = await this.paymentV2.createCart(cartPayload);
    this.storage.checkFromSession('cartData', cartResp.cart);
    this.setConfig({
      cart: cartResp.cart,
      fundraiser: cartResp.fundraiser
    });
    if (type === 'lastPay') {
      this.lastModePay(this.lastPaymentMode);
    } else if (type === 'changePay') {
      this.screenName = 'options';
      this.paymentUtil.cartResponse.next(this.config.cart);
      let optParams = `&mobile_no=${this.config?.user?.phone_1}&is_mobile=${this.util.isMobile() ? 1 : 0}&amount=${this.config.amount}`;
      this.paymentService.getPaymentOptions(this.config.currency, optParams).subscribe((res: any) => {
        this.setConfig({ paymentOptions: res.data });
        this.paymentUtil.paymentOptionsObs.next(res.data);
      });
      if (this.landingCurrency = 'INR') {
        this.paymentUtil.initaiteQr = true;
      }
      this.openPaymentPopup(this.screenName, template);
      this.util.router.navigate([], { queryParams: { payment: 'options' }, queryParamsHandling: 'merge' });
      this.events.sendSystemEvent({
        eventName: 'paymode_changed',
        pageName: this.vars.pageName
      }).subscribe(_ => _);
    }
  }

  /** OTP varification for one tap payment */
  otpVerified = (isVarified) => {
    this.oneTapOtpPopup = isVarified;
    if (isVarified) {
      this.paymentV2.otpVerified = isVarified;
      this.lastModePay(this.lastPaymentMode);
    }
  }

  lastModePay(data) {
    let payload: any = {
      mode: data.payment_mode,
      mode_value: data.payment_mode_value,
    };

    if (data.payment_mode_value === 'VPA') {
      payload.VPA = data.checksum;
      payload.origin_vpa = 'payment_form';
    }

    const isLoggedIn = this.util.getUser()?.user?.isLoggedIn;
    if (data.checksum && data.payment_gateway.match('stripe') && !this.oneTapOtpPopup && !isLoggedIn && this.config.currency !== 'INR') {
      this.oneTapOtpPopup = true;
      return;
    }
    if (data.payment_mode === 'CARD' && data.checksum) {
      payload = Object.assign(payload, {
        card_name_fill: this.config.user.full_name,
        customer_id: data.checksum.customer_id,
        donor_pincode: this.config.user.pincode
      });
    }
    this.paymentV2.preUsedOptionEvent(this.config.fundraiser, this.config.cart, payload.mode);
    this.submitPayment(payload);
  }

  async submitPayment(data) {
    this.vars.event_info.info_1 = `${JSON.stringify(this.config.paymentDetails.slabs)}/${this.config.cart.donated_amount}`;
    this.oneTapOtpPopup = false;
    Object.assign(data, {
      ct: this.config.fundraiser.custom_tag,
      origin: this.config.origin,
      options: this.config.paymentOptions,
      fundraiser: this.config.fundraiser,
      cart: this.config.cart,
      user: this.config.user,
    });
    await this.paymentV2.createOrder(data);
  }

  setAmount(amount, type?: 'tip' | '') {
    if (type === 'tip') {
      this.setConfig({
        amount: this.config.tip_only ? amount : this.config.amount,
        tipAmount: amount,
        donateBtnLabel: this.config.showTipCard ? `Tip <span class="amount-otd">${this.util.formatAmount(amount, this.config.currency) || this.util.getCurrencyIcon(this.landingCurrency).symbol + '0'}</span>` : `${this.InputConfig?.donateBtnLabel || 'Donate'} <span class="amount-otd">${this.util.formatAmount(amount, this.config.currency) || ''}</span>`,
      });
    } else {
      this.setConfig({
        amount: amount,
        donateBtnLabel: `${this.InputConfig?.donateBtnLabel || 'Donate'} <span class="amount-otd">${this.util.formatAmount(amount, this.config.currency) || ''}</span>`,
      });
    }
    if (amount > 100000 && this.lastPaymentMode?.payment_mode === 'UPI') {
      this.lastPaymentMode = null;
    } else if (!this.lastPaymentMode && amount <= 100000) {
      this.setLastPayMode(this.config.currency);
    }
  }

  openPaymentPopup(screenName, template, iconClicked?) {
    this.screenName = screenName;
    this.loadPayment = true;
    if (this.params['st'] === 'f' && iconClicked === 'editDetails') {
      this.util.router.navigate([], { queryParams: { payment: 'form' }, queryParamsHandling: 'merge' });
    }
    if (iconClicked === 'editDetails' && this.config?.theme?.match('v1')) {
      this.events.sendSystemEvent({
        eventName: 'qd_edit',
        page_name: this.vars.pageName,
      }).subscribe(_ => _);
      this.paymentV2.eventForInitiatePayment(9, this.config.fundraiser);
    }
    this.dialog.open(template, {
      height: this.isMobile ? '100vh' : '550px',
      width: '100vw',
      maxWidth: this.isMobile ? '100vw' : '660px',
      panelClass: 'payment-dialog',
      disableClose: true,
      closeOnNavigation: false
    });
  }

  enableTip() {
    this.setConfig({
      showTip: true,
      frtip: false,
      donatingAs: false,
      showTipCard: true,
      show_popular_tip: true,
    });
    this.vars.showSocialShare = false;
    this.paymentV2.eventForInitiatePayment(9, this.config.fundraiser);
    this.getContributeDetails(this.landingCurrency);
  }

  setConfig(data: IPaymentSipConfig) {
    this.config = { ...this.config, ...data };
  }

}
